function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIspacePlusLogoCleaned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82.521187mm",
    height: "15.317178mm",
    viewBox: "0 0 82.521187 15.317178",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title33"
  }, "Logo iSPACE plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title33"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-536.00173,-53.588269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g109-3",
    transform: "translate(527.79607,4.5993475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4-4",
    transform: "translate(136.37426,-89.887029)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontWeight: "bold",
      fontSize: "21.1667px",
      fontFamily: "'DIN Alternate'",
      InkscapeFontSpecification: "'DIN Alternate Bold'",
      letterSpacing: "0.390929px",
      fill: "#005740",
      strokeWidth: 0.492509,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m -128.16862,154.06885 h 2.16008 V 143.3408 h -2.16008 z m 0,-12.9088 h 2.16008 v -2.16007 h -2.16008 z m 5.78595,9.2501 -1.49861,1.71566 q 2.40812,2.06706 5.75676,2.06706 5.17799,-0.062 5.29167,-4.38217 0,-1.60197 -1.00252,-2.8112 -1.01286,-1.2299 -3.1316,-1.51929 -1.07487,-0.13436 -1.69499,-0.23771 -1.11621,-0.20671 -1.62264,-0.74414 -0.50643,-0.5271 -0.50643,-1.17823 0.0207,-1.0852 0.75448,-1.63298 0.7028,-0.5271 1.757,-0.5271 2.03605,0.0413 3.73104,1.15756 v 0 l 1.27125,-1.88103 q -2.0774,-1.49862 -4.8886,-1.56063 -2.33578,0.0207 -3.60702,1.21957 -1.31259,1.20923 -1.31259,3.18327 0,1.64331 1.04387,2.79053 1.01286,1.11622 2.9559,1.43661 1.0852,0.15503 1.99471,0.27905 1.98438,0.34107 1.96371,2.02572 -0.0413,2.05673 -2.97657,2.09807 -2.48047,-0.0207 -4.27882,-1.49862 z m 14.63298,-9.2501 h 3.29696 q 0.93018,-0.0207 1.63298,0.42375 0.46509,0.26872 0.72347,0.73381 0.24805,0.51676 0.24805,1.27124 0,0.90951 -0.60978,1.65365 -0.64079,0.76481 -1.91203,0.78548 h -3.37965 z m -2.2841,12.9088 h 2.2841 v -5.88079 h 3.47266 q 2.32545,-0.0413 3.53468,-1.48828 1.178221,-1.3746 1.178221,-3.04892 0,-1.24023 -0.465091,-2.14974 -0.44442,-0.94051 -1.15755,-1.44694 -0.8475,-0.6718 -1.67432,-0.88884 -0.82682,-0.16536 -1.71566,-0.16536 h -5.45704 z m 14.033527,-5.39503 2.180749,-6.58359 h 0.04134 l 2.180749,6.58359 z m 6.221853,5.39503 h 2.408125 l -5.47771,-15.06887 h -1.912031 l -5.477714,15.06887 h 2.418464 l 1.157554,-3.36931 h 5.715422 z m 11.770097,-4.21681 q -0.950847,2.05673 -2.873214,2.05673 -0.806153,0 -1.38493,-0.34107 -0.589113,-0.28938 -0.950848,-0.75447 -0.444418,-0.48576 -0.589113,-1.27125 -0.165364,-0.78548 -0.165364,-3.00757 0,-2.22209 0.165364,-3.02824 0.144695,-0.76481 0.589113,-1.25057 0.361735,-0.46509 0.950848,-0.77515 0.578777,-0.29973 1.38493,-0.3204 1.095542,0.0207 1.860355,0.63046 0.733806,0.64079 1.012859,1.55029 h 2.418461 q -0.361735,-1.89136 -1.736331,-3.17293 -1.374595,-1.27125 -3.555344,-1.29192 -1.777672,0.0207 -2.966232,0.8475 -1.20923,0.81649 -1.757001,1.86035 -0.341065,0.54777 -0.50643,1.43661 -0.15503,0.88883 -0.15503,3.514 0,2.58383 0.15503,3.49333 0.08268,0.48576 0.206706,0.80616 0.134359,0.31006 0.299724,0.65112 0.547771,1.04387 1.757001,1.83969 1.18856,0.82682 2.966232,0.86816 1.963708,0 3.400315,-1.11621 1.395266,-1.12655 1.89136,-3.22462 z m 4.421696,4.21681 h 9.622167 v -2.16008 h -7.338065 v -4.42351 h 6.263194 v -2.02572 h -6.263194 v -4.29949 h 7.338065 v -2.16007 h -9.622167 z",
    id: "text1-2-6-7-0-0-1",
    "aria-label": "iSPACE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g51-1-1-0-38",
    transform: "matrix(1.0211333,0,0,1.0211333,-85.932103,-50.478536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1-4-5-8-0-7",
    style: {
      fill: "#005740",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 24.450926,189.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-6-2-4-6-4",
    style: {
      fill: "#005740",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 28.450926,189.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-1-0-7-9-1-27",
    style: {
      fill: "#81b62c",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 32.450928,189.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-18-6-6-6-3-7",
    style: {
      fill: "#005740",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 28.450926,185.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-1-9-6-1-3-8-9",
    style: {
      fill: "#81b62c",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 32.450928,185.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-18-3-1-4-7-93-3",
    style: {
      fill: "#ee8434",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 28.450926,197.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-1-9-1-8-2-8-4-1",
    style: {
      fill: "#005740",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 32.450928,197.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-1-2-4-3-8-46-98",
    style: {
      fill: "#81b62c",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 36.450928,189.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-3-9-2-2-0-65",
    style: {
      fill: "#ee8434",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 24.450926,193.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-2-6-2-9-6-0",
    style: {
      fill: "#ee8434",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 28.450926,193.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-1-21-3-1-1-6-2",
    style: {
      fill: "#005740",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 32.450928,193.43579 h 3 v 3 h -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-8-1-2-6-7-6-3-1-8",
    style: {
      fill: "#005740",
      strokeWidth: 0.499999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 36.450928,193.43579 h 3 v 3 h -3 z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIspacePlusLogoCleaned);
export default __webpack_public_path__ + "static/media/ispace_plus_logo_cleaned.f1934dc9927985de2a2167e9e730e076.svg";
export { ForwardRef as ReactComponent };